import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { useLocation } from 'react-router-dom';
import Routes from './routes';
import AnalyticsConsent from './components/AnalyticsConsent';
import WhatsAppButton from './components/WhatsAppButton';
import { trackGoogleAnalyticsPageView } from './analytics/googleAnalytics';
import { trackPostHogPageView } from './analytics/posthog';

import 'react-lazy-load-image-component/src/effects/blur.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

import 'scss/react-images.scss';
import 'scss/slick-slider.scss';

const browserHistory = createBrowserHistory();

const AnalyticsPageviewTracker = () => {
  const location = useLocation();

  React.useEffect(() => {
    trackGoogleAnalyticsPageView();
    trackPostHogPageView();
  }, [location.pathname, location.search]);

  return null;
};

const App = () => {
  return (
    <Router history={browserHistory}>
      <AnalyticsPageviewTracker />
      <AnalyticsConsent />
      <Routes />
      <WhatsAppButton />
    </Router>
  );
};

export default App;
